import { Controller } from "@hotwired/stimulus"

// Manages aria-expanded state for the profile dropdown menu.
// The menu visibility is handled via CSS :focus-within for keyboard/desktop
// and click events for touch/mobile devices.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  handleFocusIn() {
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  handleFocusOut(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.close()
    }
  }

  handleClickOutside(event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.close()
    }
  }

  open() {
    this.isOpen = true
    this.element.classList.add("is-open")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.isOpen = false
    this.element.classList.remove("is-open")
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }
}
